
    // Vue, third party
    import { Component, Watch, Vue, Mixins, Prop } from "vue-property-decorator";
    import { State, Getter, Action, Mutation, namespace } from "vuex-class";

    // Third Party Components
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import vselect3 from "vselect3";

    // Sv components
    import NavHeader from "@/components/NavHeader.vue";
    import AddNewTask from "@/components/tasks/AddNewTask.vue";
    import EditLibraryTask from "@/components/tasks/EditLibraryTask.vue";
    import AddSubAction from "@/components/tasks/AddSubAction.vue";
    import ActionList from "@/components/actions/ActionList.vue";
    import ActionModal from "@/components/actions/ActionModal.vue";
    import ActionCategoryModal from "@/components/actions/ActionCategoryModal.vue";

    // Mixin / Filters
    import { parseTaskText } from "@/filters";
    import ActionsMixin from "@/mixins/ActionsMixin";

    // Types
    import { ActionPlan, TaskCategory, TaskLibrary, TaskType, NewTask } from '@/store/tasks/types';

    // Namespaces
    const Tasks = namespace("tasks");

    @Component({
        components: {
            "nav-header": NavHeader,
            "vue-perfect-scrollbar": VuePerfectScrollbar,
            "add-new-task": AddNewTask,
            "edit-library-task":  EditLibraryTask,
            "action-list": ActionList,
            vselect3,
            "action-category-modal": ActionCategoryModal,
            "action-modal": ActionModal,
            "subaction-modal": AddSubAction
        },
        filters: {
			parseTaskText
		}
    })
    export default class ActionLibrary extends Mixins(ActionsMixin) {
        @Prop({ type: Boolean, default: false }) isActionSetupLoading: boolean;
        
        @Tasks.State(state =>  state.TaskCategories) actionCategories: TaskCategory[];
        @Tasks.State(state => state.TaskLibrary) taskLibrary: TaskLibrary[];
        @Tasks.State(state => state.TaskTypes) taskTypes: TaskType[];

        private currentAction: TaskLibrary = null;
        private deleteCurrentAction: TaskLibrary = null;
        private parentAction: TaskLibrary = null;
        private actionModal: boolean = false;
        private categoryModal: boolean = false;
        private search: string = "";   
        private showSubModal: boolean = false;
        
        /**
         * @summary method to set the current action to edit
         * @returns void
         */
        private setCurrentActionToEdit(action: TaskLibrary): void {
            this.currentAction = action;
        }

        /**
         * @summary method to set the current action to delete
         * @returns void
         */
        private setCurrentActionToDelete(action: TaskLibrary): void {
            this.deleteCurrentAction = action;
        }

        /**
         * @summary method to add a sub action to the current action
         * @returns void
         */
        private addSubAction(action: TaskLibrary): void {
            this.parentAction = action;
            this.showSubModal = true;
        }
        /**
         * @summary method to close the sub action modal
         * @returns void
         */
        private closeSubAction(): void {
            this.parentAction = null;
            this.showSubModal = false;
        }
    }
